<template>
<v-card></v-card>
</template>

<script>
import LZString from 'lz-string';

export default {
  name: 'ResultsForwarder',
  methods: {
    bin_to_utf: function(bin) {
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = bin.charCodeAt(i);
      }

      const charCodes = new Uint16Array(bytes.buffer);
      let result = '';
      for (let i = 0; i < charCodes.length; i++) {
        result += String.fromCharCode(charCodes[i]);
      }
      return result;
    },
  },
  mounted() {
    if (!this.$route.query.data) {
      this.$router.push('/');
    }

    const query_lz = this.$route.query.data;
    const query_json = LZString.decompressFromEncodedURIComponent(query_lz);
    const query = JSON.parse(query_json); 

    console.log(query);
    this.$router.push({
      path: 'results',
      query: query
    });
  }
}
</script>